const MONTH_LABELS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const normalizePhone = (value) => {
  if (value === null || value === undefined) return "";
  const raw = String(value).trim();
  let numericLike = null;
  if (/e\+/i.test(raw)) {
    numericLike = Number.parseFloat(raw);
  } else if (Number.isFinite(Number(raw))) {
    numericLike = Number(raw);
  }
  const candidate =
    numericLike !== null && !Number.isNaN(numericLike)
      ? Math.trunc(numericLike).toString()
      : raw;
  const digits = candidate.replace(/\D/g, "");
  if (digits.startsWith("0") && digits.length === 10) return `254${digits.slice(1)}`;
  if ((digits.startsWith("7") || digits.startsWith("1")) && digits.length === 9)
    return `254${digits}`;
  if (digits.startsWith("254")) return digits.slice(0, 12);
  return digits;
};

export const getTransactionDate = (tx) => {
  const value =
    tx?.transactionDate || tx?.processedAt || tx?.TransactionDate || tx?.ProcessedAt;
  const date = value?.toDate ? value.toDate() : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const getTransactionTime = (tx) => {
  const date = getTransactionDate(tx);
  return date ? date.getTime() : 0;
};

export const getTransactionAmount = (tx) =>
  Number(
    tx?.transactionAmount ??
      tx?.amount ??
      tx?.TransactionAmount ??
      tx?.Amount ??
      0
  ) || 0;

export const buildB2CMonthlySeries = (payments = [], year) => {
  const targetYear = year || new Date().getFullYear();
  const totals = Array(12).fill(0);
  const actualMonths = new Set();

  payments.forEach((tx) => {
    const date = getTransactionDate(tx);
    if (!date || date.getFullYear() !== targetYear) return;
    const amount = getTransactionAmount(tx);
    if (!amount) return;
    totals[date.getMonth()] += amount;
    actualMonths.add(date.getMonth());
  });

  const actualIndices = Array.from(actualMonths).sort((a, b) => a - b);
  const lastActual =
    actualIndices.length > 0 ? actualIndices[actualIndices.length - 1] : -1;
  const avg =
    actualIndices.length > 0
      ? actualIndices.reduce((sum, idx) => sum + totals[idx], 0) /
        actualIndices.length
      : 0;

  return MONTH_LABELS.map((label, idx) => {
    const actual = totals[idx] ? Number(totals[idx].toFixed(2)) : null;
    let projection = null;
    if (lastActual >= 0 && idx > lastActual) {
      const base = avg;
      if (base > 0) {
        projection = Number(base.toFixed(2));
      }
    }
    return { month: label, actual, projection };
  });
};
